import { actionTypes } from '../../../types';

const initialState = {
    status: null,
    message: '',
    data: {},
    isLoading: false,
};

const appleUserLoginReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.APPLE_USER_LOGIN_REQUEST:
            return { ...state, isLoading: true, status: null, message: '' };
        case actionTypes.APPLE_USER_LOGIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                status: action.payload.status,
                message: action.payload.message,
                data: action.payload.response,
            };
        case actionTypes.APPLE_USER_LOGIN_FAILURE:
            return {
                ...state,
                isLoading: false,
                status: action.payload.status,
                message: action.payload.message,
                data: {},
            };
        case actionTypes.APPLE_USER_LOGIN_RESET:
            return { ...initialState };
        case actionTypes.APPLE_USER_LOGIN_RESET_ALL:
            return { ...initialState };
        default:
            return state;
    }
};

export default appleUserLoginReducer;
